export const trendingConstants = {
    TRENDING_LIST_REQUEST: 'TRENDING_LIST_REQUEST',
    TRENDING_LIST_SUCCESS: 'TRENDING_LIST_SUCCESS',
    TRENDING_LIST_ERROR: 'TRENDING_LIST_ERROR',
    TRENDING_SEARCH_REQUEST: 'TRENDING_SEARCH_REQUEST',

    TRENDING_ADD_REQUEST : 'TRENDING_ADD_REQUEST',
    TRENDING_ADD_SUCCESS : 'TRENDING_ADD_SUCCESS',
    TRENDING_ADD_FAILURE :'TRENDING_ADD_FAILURE',

    TRENDING_DELETE_REQUEST : 'TRENDING_DELETE_REQUEST',
    TRENDING_DELETE_SUCCESS : 'TRENDING_DELETE_SUCCESS',
    TRENDING_DELETE_FAILURE : 'TRENDING_DELETE_FAILURE',


    ACTIVE_TRENDING_GET_REQUEST : 'ACTIVE_TRENDING_GET_REQUEST',
    ACTIVE_TRENDING_GET_SUCCESS : 'ACTIVE_TRENDING_GET_SUCCESS',
    ACTIVE_TRENDING_GET_FAILURE : 'ACTIVE_TRENDING_GET_FAILURE',
};
